import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const ChartSkeleton = styled.div`
  flex: 1;
  min-height: 7.5rem;
  width: 100%;
  border-radius: 0.375rem;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.lightGrey} 0%,
    ${({ theme }) => theme.grey} 45%,
    ${({ theme }) => theme.lightGrey} 90%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.6s ease-in-out infinite;
`;

export const SkeletonWrap = styled.div<{ $gap?: string; $padding?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || '0.85rem'};
  padding: ${({ $padding }) => $padding || '0'};
  width: 100%;
`;

export const SkeletonRow = styled.div<{ $justify?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $justify }) => $justify || 'flex-start'};
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SkeletonField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  min-height: 4.5rem;
`;

export const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid ${({ theme }) => theme.grey};
  background: ${({ theme }) => theme.background};
`;

export const SkeletonCardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;
